import { StyleSheet } from 'react-native';

import { heightPercentageToDP, isWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    title: {
        width: '100%',
        paddingBottom: heightPercentageToDP(16),
        zIndex: isWeb ? 1000 : 1,
        ...(isWeb
            ? {
                  minHeight: heightPercentageToDP(30),
              }
            : {}),
    },
    gradientContainer: {
        position: 'absolute',
        top: isWeb ? 25 : heightPercentageToDP(24),
        left: 0,
        right: 0,
        height: heightPercentageToDP(72),
    },
    gradient: {
        height: heightPercentageToDP(72),
    },
});

export default styles;
